import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import Chart from 'chart.js/auto';
import * as moment from 'moment';
import { DoctorDashboardService } from 'src/app/services/doctor-dashboard.service/doctor-dashboard.service';

@Component({
  selector: 'app-chart-patient',
  templateUrl: './chart-patient.component.html',
  styleUrls: ['./chart-patient.component.css'],
})
export class ChartPatientComponent implements OnInit, AfterViewInit {
  @ViewChild('patientCanvas') patientCanvas!: ElementRef;

  private chart!: Chart;
  private chartInitialized = false;

  public patients: Array<number> = [];
  debutSemaine: number = 0;
  finSemaine: number = 0;

  constructor(
    private doctorDashboardService: DoctorDashboardService,
    private ngZone: NgZone
  ) {}

  get canvasContext(): any {
    return this.patientCanvas.nativeElement.getContext('2d');
  }

  ngOnInit(): void {
    const semaine = this.inetrval();
    this.debutSemaine = semaine[0];
    this.finSemaine = semaine[6];
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.staticPatient();
      this.chartInitialized = true;
    });
  }

  dateApresDayActule(): number {
    const dateActuelle = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    var dateFinSemaineInter = new Date(dateActuelle);
    const startDate = dateFinSemaineInter.setDate(dateActuelle.getDate() - 7);
    return startDate;
  }

  dateActule(): number {
    return new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    ).getTime();
  }

  inetrval(): any {
    const dateActuelle = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    var dateFinSemaine = new Date(dateActuelle);
    return [
      dateFinSemaine.setDate(dateActuelle.getDate() - 7),
      new Date(dateActuelle).setDate(dateActuelle.getDate() - 6),
      new Date(dateActuelle).setDate(dateActuelle.getDate() - 5),
      new Date(dateActuelle).setDate(dateActuelle.getDate() - 4),
      new Date(dateActuelle).setDate(dateActuelle.getDate() - 3),
      new Date(dateActuelle).setDate(dateActuelle.getDate() - 2),
      new Date(dateActuelle).setDate(dateActuelle.getDate() - 1),
      new Date(dateActuelle).setDate(dateActuelle.getDate()),
    ];
  }

  staticPatient() {
    if (!this.patientCanvas) return; // guard important

    const startDate = this.dateApresDayActule();
    const endDate = this.dateActule();
    const intervialle = this.inetrval();

    this.doctorDashboardService.staticPatient(startDate, endDate).subscribe((res) => {
      this.patients = []; // reset avant de remplir

      for (let date of intervialle) {
        let found = false;
        if (res !== null) {
          for (let item of res) {
            if (item.creationDate === date) {
              this.patients.push(item.pCount);
              found = true;
              break;
            }
          }
        }
        if (!found) {
          this.patients.push(0);
        }
      }

      this.chart?.destroy(); // détruire l'ancien chart si existant

      this.chart = new Chart(this.canvasContext, {
        type: 'line',
        data: {
          labels: intervialle.map((elm) =>
            moment(new Date(elm)).format('DD/MM/YYYY')
          ),
          datasets: [
            {
              label: 'Nombre de Patients',
              data: this.patients,
              fill: true,
              tension: 0.6,
              backgroundColor: 'transparent',
              borderColor: 'rgba(168, 50, 117, 1)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          color: '#a83275',
          responsive: true,
        },
      });
    });
  }
}